import { SITE_KEY } from "../siteConfig";

// One Google Analytics property per site.
// Which one is used is decided at build time by VITE_SITE (see siteConfig.js).
export const gaIdBySite = {
  india: "G-FMFVPY8V2X",
  navimumbai: "G-FMFVPY8V2X",
  pune: "G-N0V6JQFYCL",
  bangalore: "G-DLLNKE6635",
  shirdi: "G-J3EK9LZ6JK",
};

export const GA_ID = gaIdBySite[SITE_KEY];